<template>
  <div class="container">redirecting to Dafater .....</div>
  <post-form
    v-if="
      $msal.accounts[0] &&
      $msal.accounts[0].idTokenClaims.hasOwnProperty('extension_vmlink') &&
      $msal.accounts[0].idTokenClaims.extension_vmlink
    "
    @emitRefs="(button) => (submitBtn = button)"
    :action="$msal.accounts[0].idTokenClaims.extension_vmlink"
    :nameIdentifier="$msal.accounts[0].localAccountId"
    :cmd="'login'"
  />
</template>
<script>
import PostForm from "@/components/PostForm.vue";
export default {
  components: { PostForm },
  data() {
    return {
      submitBtn: null,
    };
  },
  mounted() {
    if (
      this.$msal.accounts[0] &&
      this.$msal.accounts[0].idTokenClaims.hasOwnProperty("extension_vmlink") &&
      this.$msal.accounts[0].idTokenClaims.extension_vmlink
    ) {
      let extension_VMLinks =
        this.$msal.accounts[0].idTokenClaims.extension_vmlink.split(",");
      if (extension_VMLinks.length == 1) {
        this.submitBtn.click();
      } else {
        this.$router.replace("/not-auth");
      }
    } else {
      this.$router.replace("/not-auth");
      console.log("Not authorized");
    }
  },
};
</script>

<style lang="scss" scoped>
</style>